export default "__VITE_ASSET__03987d5f__"